import { Component, OnDestroy, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { filter, first, tap } from 'rxjs/operators';
import { AppState } from 'src/app/reducers';
import { SEVERITY_COLOR, UsuarioExpiracionClave, UsuarioExpiracionClaveSeverity } from 'src/app/session/store/session';
import { sessionUsuarioExpiracionClave } from 'src/app/session/store/session.selectors';

@Component({
	selector: 'vencimiento-clave',
	templateUrl: './vencimiento-clave.component.html',
	styleUrls: ['./vencimiento-clave.component.scss']
})
export class VencimientoClaveComponent implements OnDestroy, OnInit {

	private readonly FONT_FAMILY_NORMAL: string = "var(--font-family-normal)";
	private readonly FONT_FAMILY_BOLD: string = "var(--font-family-bold)";

	@Input()
	color: string;

	private messageStyleSubject: Subject<Object> = new BehaviorSubject<Object>( null );
	messageStyle$: Observable<Object>;
	expiracionClave$: Observable<UsuarioExpiracionClave>;

	private expiracionSubscription: Subscription;


	constructor( private store: Store<AppState>  ) {
	}

	ngOnInit(): void {
		this.messageStyle$ = this.messageStyleSubject.asObservable();

		this.expiracionClave$ = this.store.select( sessionUsuarioExpiracionClave );

		this.expiracionSubscription = this.store.select( sessionUsuarioExpiracionClave )
			.pipe(
				filter( expiracion => expiracion != null ),
				tap( expiracion => {
					let actualSeverity: UsuarioExpiracionClaveSeverity = UsuarioExpiracionClaveSeverity[ expiracion.severity ];
					let color: string = this.color && actualSeverity == UsuarioExpiracionClaveSeverity.NORMAL? this.color: SEVERITY_COLOR[ actualSeverity ];
					let fontFamily: string = actualSeverity == UsuarioExpiracionClaveSeverity.NORMAL? this.FONT_FAMILY_NORMAL: this.FONT_FAMILY_BOLD;
					this.messageStyleSubject.next( { color, 'font-family': fontFamily } );
				})
			).subscribe();
	}

	ngOnDestroy(): void {
		if( this.expiracionSubscription )
			this.expiracionSubscription.unsubscribe();
	}

}
